module.exports = {
	"id": "LI",
	"name": "Liechtenstein",
	"month": "2016-10",
	"access_date": "2016-11-03",
	"data": {
		"chrome": {
			"4": null,
			"5": null,
			"6": null,
			"7": null,
			"8": null,
			"9": null,
			"10": null,
			"11": null,
			"12": null,
			"13": null,
			"14": null,
			"15": null,
			"16": null,
			"17": null,
			"18": null,
			"19": null,
			"20": null,
			"21": null,
			"22": 0.013016,
			"23": null,
			"24": null,
			"25": null,
			"26": 0.169208,
			"27": null,
			"28": null,
			"29": 0.052064,
			"30": null,
			"31": null,
			"32": 0.006508,
			"33": null,
			"34": 0.013016,
			"35": null,
			"36": 0.006508,
			"37": 0.006508,
			"38": 0.013016,
			"39": 0.006508,
			"40": 0.006508,
			"41": null,
			"42": null,
			"43": 0.091112,
			"44": 0.013016,
			"45": 0.266828,
			"46": 0.019524,
			"47": 0.091112,
			"48": 0.052064,
			"49": 0.403496,
			"50": 0.039048,
			"51": 0.754928,
			"52": 0.136668,
			"53": 13.217748,
			"54": 3.117332,
			"55": 0.013016,
			"56": null,
			"57": null
		},
		"firefox": {
			"2": null,
			"3": null,
			"4": null,
			"5": null,
			"6": null,
			"7": null,
			"8": null,
			"9": 0.071588,
			"10": null,
			"11": null,
			"12": 0.013016,
			"13": null,
			"14": null,
			"15": null,
			"16": 0.013016,
			"17": null,
			"18": null,
			"19": null,
			"20": 0.006508,
			"21": 0.006508,
			"22": null,
			"23": 0.006508,
			"24": null,
			"25": 0.039048,
			"26": null,
			"27": null,
			"28": 0.006508,
			"29": null,
			"30": 0.045556,
			"31": null,
			"32": 0.006508,
			"33": 0.058572,
			"34": 0.013016,
			"35": 0.013016,
			"36": 0.052064,
			"37": 0.006508,
			"38": 0.006508,
			"39": 0.039048,
			"40": 0.013016,
			"41": 0.013016,
			"42": 0.039048,
			"43": 0.045556,
			"44": 0.019524,
			"45": 0.169208,
			"46": 0.104128,
			"47": 0.436036,
			"48": 1.1389,
			"49": 10.497404,
			"50": 0.019524,
			"51": null,
			"52": null,
			"3.5": null,
			"3.6": null
		},
		"opera": {
			"9": null,
			"11": 0.039048,
			"12": 0.013016,
			"15": null,
			"16": null,
			"17": null,
			"18": null,
			"19": null,
			"20": null,
			"21": null,
			"22": null,
			"23": null,
			"24": null,
			"25": null,
			"26": null,
			"27": null,
			"28": null,
			"29": null,
			"30": null,
			"31": null,
			"32": null,
			"33": null,
			"34": null,
			"35": null,
			"36": 0.078096,
			"37": 0.006508,
			"38": null,
			"39": 0.058572,
			"40": 0.240796,
			"41": 0.045556,
			"42": null,
			"43": null,
			"9.5-9.6": null,
			"10.0-10.1": 0,
			"10.5": null,
			"10.6": null,
			"11.1": null,
			"11.5": null,
			"11.6": null,
			"12.1": 0.091112
		},
		"safari": {
			"0": null,
			"4": 0.006508,
			"5": 0.188732,
			"6": 0.013016,
			"7": 0.026032,
			"8": 0.253812,
			"9": 0.396988,
			"10": 4.021944,
			"3.1": null,
			"3.2": null,
			"5.1": 0.266828,
			"6.1": 0.598736,
			"7.1": 0.06508,
			"9.1": 2.225736
		},
		"ios_saf": {
			"8": 0,
			"10": 12.5622385787,
			"3.2": 0,
			"4.0-4.1": 0,
			"4.2-4.3": 0,
			"5.0-5.1": 0,
			"6.0-6.1": 0,
			"7.0-7.1": 0.338537793609,
			"8.1-8.4": 0.625434228872,
			"9.0-9.2": 0.298372292673,
			"9.3": 4.55209010616
		},
		"android": {
			"3": 0,
			"4": 0.0152897726098,
			"53": null,
			"2.1": 0,
			"2.2": 0,
			"2.3": 0.00191122157623,
			"4.1": 0.0551523940568,
			"4.2-4.3": 0.137880985142,
			"4.4": 0.316170655039,
			"4.4.3-4.4.4": 0.318900971576
		},
		"ie": {
			"6": null,
			"7": 0.00651988892948,
			"8": 0.189076778955,
			"9": 0.560710447936,
			"10": 0.469432002923,
			"11": 16.6191968813,
			"5.5": null
		},
		"op_mob": {
			"0": 0.00192709215841,
			"10": 0,
			"11": 0,
			"12": 0,
			"11.1": 0,
			"11.5": 0,
			"12.1": 0.0000535303377337
		},
		"edge": {
			"12": 0.078096,
			"13": 1.386204,
			"14": 3.963372
		},
		"ie_mob": {
			"10": 0.0537233239437,
			"11": 0.218730676056
		},
		"bb": {
			"7": 0.00436625,
			"10": null
		},
		"samsung": {
			"0": 4.50597
		},
		"and_uc": {
			"0": 0.031437
		},
		"op_mini": {
			"0": 0.0259633775039
		},
		"and_chr": {
			"0": 10.480984
		},
		"and_ff": {
			"0": 0.055888
		}
	},
	"total": 97.91735425
};


/*****************
 ** WEBPACK FOOTER
 ** ./~/caniuse-db/region-usage-json/LI.json
 ** module id = 574
 ** module chunks = 0
 **/